import axios from "axios";
import { API_URL } from "../../utils/api-utils";
import { common } from "../../utils";
//Master
export const GetModuleMasterList = async (param) => {
  let url =  `${API_URL.Lobby}/api/Portal/GetModuleMasterList`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveModule = async (param) => {
    let url =  `${API_URL.Lobby}/api/Portal/SaveModule`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
  };

  

  